import api from 'core/api';

export const getBusinessUnits = () => api.get('business-units/');

export const updateBusinessUnit = (id, businessUnit) => api.put(`business-units/${id}`, businessUnit);

export const updateSubGroup = (id, subGroup) => api.put(`business-units/sub-groups/${id}`, subGroup);
